import React from 'react';
import T from 'prop-types';

const Weekday = ({ weekday, locale, localeUtils, className }) => {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);

  return (
    <div className={className} title={weekdayName}>
      {weekdayName.slice(0, 1)}
    </div>
  );
};

Weekday.propTypes = {
  weekday: T.number,
  className: T.string,
  localeUtils: T.object,
  locale: T.string,
};

export default Weekday;
